<div class="basic-popup">
  <div class="svg-info-circle-container">
    <svg-info-circle></svg-info-circle>
  </div>
  <h2>{{ header }}</h2>
  <div
    class="body"
    [innerHTML]="body"
    [ngClass]="{ 'small-body': isSmallBody }"
  ></div>
  <div class="footer">
    <span>{{ footer }}</span>
  </div>
  <div class="actions">
    <button
      mat-flat-button
      color="secondary"
      i18n="@@global.cancel"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="handleClick()">
      {{ primaryButtonText }}
    </button>
  </div>
</div>
